export const CallKeyboardActions = {
    pickup: 'PICK_UP',
    decline: 'DECLINE',
    hangup: 'HANG_UP'
}

export const CallPreferences = [
    {
        id: 1,
        name: 'enter_pickup',
        type: CallKeyboardActions.pickup,
        isChecked: false
    },
    {
        id: 2,
        name: 'esc_decline',
        type: CallKeyboardActions.decline,
        isChecked: false
    },
    {
        id: 3,
        name: 'esc_hangup',
        type: CallKeyboardActions.hangup,
        isChecked: false
    }
]
